var map = {
	"./SixtemaTinexta-338x132.png": 496,
	"./SixtemaTinexta-Original.png": 301,
	"./SixtemaTinexta-Original_2022.png": 497,
	"./Whats_New.png": 498,
	"./Whats_New_180.png": 252,
	"./agency.png": 499,
	"./agencyWhite.png": 253,
	"./background.jpg": 500,
	"./businesscons.png": 501,
	"./company.png": 254,
	"./convsrl.png": 255,
	"./daddi.png": 502,
	"./dadi.png": 503,
	"./dadi2.png": 504,
	"./iForfe07_DADO.png": 505,
	"./iForfeTRI2019_bIANCO_DEF.png": 506,
	"./iForfe_new.png": 256,
	"./iforfetari.png": 507,
	"./iforfetari2019_def.jpg": 508,
	"./ind_crisis.png": 509,
	"./invio_telematico.png": 510,
	"./invio_telematico_new.png": 511,
	"./logo_Sixtema_Bianco.png": 512,
	"./logo_Sixtema_Bianco_mobile.png": 513,
	"./logo_Visura.png": 514,
	"./logo_unappa.png": 302,
	"./logo_wki.png": 303,
	"./logo_wki_mobile.png": 515,
	"./report.png": 257,
	"./sixtema.png": 516,
	"./sk_budget.png": 258,
	"./telematico.jpg": 517,
	"./telematico_new.jpg": 518,
	"./telematico_new.png": 259,
	"./users.png": 260,
	"./whatsnew.jpg": 519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 300;